var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0279 36.5682L16.1309 43.3697C14.1174 44.9089 11.2201 43.4711 11.2159 40.9402L11.2083 36.3081C7.06576 35.312 4 31.5716 4 27.1281V15.4401C4 10.2282 8.21208 6 13.4118 6H34.5882C39.7879 6 44 10.2282 44 15.4401V27.1281C44 32.34 39.7879 36.5682 34.5882 36.5682H25.0279ZM15.2128 39.0366L23.1363 32.9793C23.4851 32.7127 23.9119 32.5682 24.351 32.5682H34.5882C37.5754 32.5682 40 30.1343 40 27.1281V15.4401C40 12.4339 37.5754 10 34.5882 10H13.4118C10.4246 10 8 12.4339 8 15.4401V27.1281C8 30.0777 10.3381 32.4859 13.2603 32.5661C14.3418 32.5958 15.2036 33.4802 15.2054 34.5621L15.2128 39.0366Z",
    fill: "#FFA372"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.bc2cfbef.svg";
export { ForwardRef as ReactComponent };